import React, { useState } from 'react';
import { View, Text } from 'react-native'
import { DateTime } from 'luxon';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './styles';

const ARAgingDetail = () => {
  const [days, setDays] = useState(30);

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'ar-aging-detail',
      params: { days },
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>A/R Aging Detail</Text>
      <Text style={styles.label}>Minimum Days Past Due:</Text>
      <input
        style={styles.select}
        onChange={e => setDays(e.target.value)}
        value={days}
      />
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default ARAgingDetail;
